// biome-ignore lint/complexity/noBannedTypes: this is ok
export type AnyObject = {};
export type WithoutNull<T> = { [P in keyof T]: null extends T[P] ? Exclude<T[P], null> | undefined : T[P] };
export type WithoutNullish<T> = { [K in keyof T]: NonNullable<T[K]> };

export const isNil = (v: any): boolean => v === null || v === undefined;

/**
 * Throws error if value is null or undefined
 *
 * @param errMsg
 * @returns
 */
export function assertNotNull<T>(v: T, errorOrMsg: string | Error = 'Expected non null value'): NonNullable<T> {
  if (nonNullable(v)) return v;
  throw typeof errorOrMsg === 'string' ? new Error(errorOrMsg) : errorOrMsg;
}

/**
 * Removes properties from object which is null or undefined
 */
export function withoutNullish<T extends AnyObject>(obj: T): WithoutNullish<T> {
  const result: { [key: string]: any } = {};

  for (const [key, value] of Object.entries(obj)) {
    if (nonNullable(value)) result[key] = value;
  }

  return result as WithoutNullish<T>;
}

/**
 * Guard function to check if value is not null or undefined
 */
export function nonNullable<T>(value: T): value is NonNullable<T> {
  return !isNil(value);
}

/**
 * Whether any of the named keys holds a value at all.
 *
 * An undefined field is the absence of an answer rather than an answer, which is
 * what a patch means by leaving a column alone. Null is an answer here: it clears
 * the column, so it counts as something to write.
 */
export function hasAnyDefined<T extends AnyObject>(obj: T, keys: readonly (keyof T)[]): boolean {
  return keys.some((key) => obj[key] !== undefined);
}
